<template lang="pug">
.new-color
  shForm(title="Nuevo Color")
</template>

<script>
import shForm from '@/components/pages/color/Form'

export default {
  name: 'NewColor',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-color
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/color/New.vue